import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'motn-tooltip',
  template: `
    <div
      class="motn-tooltip"
      [attr.data-position]="position"
      [@tooltip]="'visible'"
      >
      <div class="motn-tooltip-content">
        @if (content && !isHtmlContent) {
          {{ content }}
        }
        @if (content && isHtmlContent) {
          <div [innerHTML]="content"></div>
        }
        @if (contentTemplate) {
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        }
      </div>
    </div>
    `,
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  animations: [
    trigger('tooltip', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'scale(0.8)' }))
      ])
    ])
  ]
})
export class TooltipComponent {
  @Input() content?: string;
  @Input() contentTemplate?: TemplateRef<any>;
  @Input() position: string = 'top';
  
  get isHtmlContent(): boolean {
    return typeof this.content === 'string' && this.content.includes('<');
  }
}